/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { MedicalServiceGroupDto } from './medical-service-group-dto';
import { MedicalServiceVisitTypeDto } from './medical-service-visit-type-dto';

/**
 * 
 * @export
 * @interface MedicalServiceDto
 */
export interface MedicalServiceDto {
    /**
     * 
     * @type {boolean}
     * @memberof MedicalServiceDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MedicalServiceDto
     */
    'adultDocplannerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalServiceDto
     */
    'adultFirstDocplannerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalServiceDto
     */
    'adultNextDocplannerId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalServiceDto
     */
    'appointingWidgetEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MedicalServiceDto
     */
    'childDocplannerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalServiceDto
     */
    'childFirstDocplannerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalServiceDto
     */
    'childNextDocplannerId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalServiceDto
     */
    'consultation'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MedicalServiceDto
     */
    'durationFrom'?: number;
    /**
     * 
     * @type {number}
     * @memberof MedicalServiceDto
     */
    'durationStep'?: number;
    /**
     * 
     * @type {number}
     * @memberof MedicalServiceDto
     */
    'durationTo'?: number;
    /**
     * 
     * @type {number}
     * @memberof MedicalServiceDto
     */
    'grossPriceCommission'?: number;
    /**
     * 
     * @type {number}
     * @memberof MedicalServiceDto
     */
    'grossPriceStep'?: number;
    /**
     * 
     * @type {number}
     * @memberof MedicalServiceDto
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalServiceDto
     */
    'isConsultation'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MedicalServiceDto
     */
    'maxAdditionalTimeGrossPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof MedicalServiceDto
     */
    'maxGrossPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof MedicalServiceDto
     */
    'medicalService'?: MedicalServiceDtoMedicalServiceEnum;
    /**
     * 
     * @type {MedicalServiceGroupDto}
     * @memberof MedicalServiceDto
     */
    'medicalServiceGroup'?: MedicalServiceGroupDto;
    /**
     * 
     * @type {number}
     * @memberof MedicalServiceDto
     */
    'minAdditionalTimeGrossPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof MedicalServiceDto
     */
    'minGrossPrice'?: number;
    /**
     * 
     * @type {Set<MedicalServiceVisitTypeDto>}
     * @memberof MedicalServiceDto
     */
    'visitTypes': Set<MedicalServiceVisitTypeDto>;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalServiceDto
     */
    'widgetPackageEnabled'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum MedicalServiceDtoMedicalServiceEnum {
    Visit0 = 'VISIT_0',
    Visit1 = 'VISIT_1',
    StandardVisit = 'STANDARD_VISIT',
    StandardVisit15 = 'STANDARD_VISIT_15',
    FollowupVisit = 'FOLLOWUP_VISIT',
    Message = 'MESSAGE',
    Prescription = 'PRESCRIPTION',
    AbsentConsultation = 'ABSENT_CONSULTATION',
    NeurosurgeonConsultation = 'NEUROSURGEON_CONSULTATION',
    NeuropsychologistConsultation = 'NEUROPSYCHOLOGIST_CONSULTATION',
    NeurologopedistConsultation = 'NEUROLOGOPEDIST_CONSULTATION',
    PsychiatristConsultation = 'PSYCHIATRIST_CONSULTATION',
    GeneticistConsultation = 'GENETICIST_CONSULTATION',
    EpileptologistConsultation = 'EPILEPTOLOGIST_CONSULTATION',
    NeurologistConsultation = 'NEUROLOGIST_CONSULTATION',
    DieticianConsultation = 'DIETICIAN_CONSULTATION',
    VnsConsultation = 'VNS_CONSULTATION',
    MetabolicConsultation = 'METABOLIC_CONSULTATION',
    SleepDisturbanceConsultation = 'SLEEP_DISTURBANCE_CONSULTATION',
    CaseConference = 'CASE_CONFERENCE',
    AdhdConsultation = 'ADHD_CONSULTATION',
    PsychotherapyConsultation = 'PSYCHOTHERAPY_CONSULTATION',
    TmsQualificationConsultation = 'TMS_QUALIFICATION_CONSULTATION',
    TmsInductionConsultation = 'TMS_INDUCTION_CONSULTATION',
    Tms15MConsultation = 'TMS_15M_CONSULTATION',
    Tms30MConsultation = 'TMS_30M_CONSULTATION',
    Tms45MConsultation = 'TMS_45M_CONSULTATION',
    EegConsultation = 'EEG_CONSULTATION',
    VeegNightConsultation = 'VEEG_NIGHT_CONSULTATION',
    VeegDayConsultation = 'VEEG_DAY_CONSULTATION',
    VeegOnStandbyConsultation1H = 'VEEG_ON_STANDBY_CONSULTATION_1H',
    VeegOnStandbyConsultation2H = 'VEEG_ON_STANDBY_CONSULTATION_2H',
    VeegOnStandbyConsultation6H = 'VEEG_ON_STANDBY_CONSULTATION_6H',
    VeegDuringSleepConsultation1H = 'VEEG_DURING_SLEEP_CONSULTATION_1H',
    VeegDuringSleepConsultation2H = 'VEEG_DURING_SLEEP_CONSULTATION_2H',
    VeegDuringSleepConsultation6H = 'VEEG_DURING_SLEEP_CONSULTATION_6H',
    MigrationVisit = 'MIGRATION_VISIT',
    VeegOnStandbyConsultation = 'VEEG_ON_STANDBY_CONSULTATION',
    VeegDuringSleepConsultation = 'VEEG_DURING_SLEEP_CONSULTATION',
    PartnerConsultation = 'PARTNER_CONSULTATION'
}


